import React from 'preact/compat';
import { h } from 'preact';
import { SingleItemPayload, ADD_ITEMS_REQUEST } from 'list/pubsub';

import RemoveFromList from './components/RemoveFromList';
import { removeFromLists } from './removeFromLists';
import { List } from 'adapters/list/graphqlTypes';

type RemoveFromListProps = {
    lists: List[];
    destroy: () => void;
    payload: SingleItemPayload;
};

export const RemoveFromListModal = ({ lists, destroy, payload }: RemoveFromListProps) => {
    const handleCloseRemoveModal = () => {
        destroy();
    };

    const moveToAnotherList = () => {
        destroy();
        window.ikea.pubsub.publish(ADD_ITEMS_REQUEST, {
            ...payload,
            quantity: '1',
        }); // Todo double check that this works
    };

    const listsContainingItem = (lists: List[], productNumber: string) => {
        const listItemQuantityMap: Record<string, number> = {};

        const matchingLists = lists.filter((list: List) =>
            list?.retail?.items?.find(item => {
                listItemQuantityMap[list.listId] = item.quantity;
                return item.itemNo === productNumber;
            })
        );

        return { matchingLists, listItemQuantityMap };
    };

    return (
        <RemoveFromList
            modalOpen={true}
            closeModal={handleCloseRemoveModal}
            payload={payload}
            removeFromLists={removeFromLists}
            lists={listsContainingItem(lists, payload.productNumber).matchingLists}
            moveToAnotherList={moveToAnotherList}
        />
    );
};

export default RemoveFromListModal;
